module.exports = __webpack_public_path__ + "img/bianji.b20fee22.png";